export default {
    listingHash: "",
    listingname: "",
    url: '',
    exportUrl: null,
    metaUrl: null,
    permissions: {
        export: false,
        favorite: false,
        create: false
    },
    linkedtype: "",
    filters: [],
    prefilter: {},
	columns: [],
	columnsSize: {},
    batchActions: [],
    kpis: [],
    display: {
        filters: true,
        filtersView: "select",
        favorites: false,
        favoritesUpdate: false,
        favoritesForm: false,
        table: false,
        columns: false,
        export: false,
        exportType: "CSV",
        batchActions: false,
        density: "condensed",
        backToFavorites: false,
        kpi: false,
        enableAllPages: true,
        visibleAllPages: false,
        checkAllPages: false,
    },
    pagination: {
        current_page: "",
        per_page: 25,
        last_page: "",
        total: ""
    },
    sorting: {
        field: "",
        direction: ""
    },
    ajax: false,
    init: true,
    rows: {},
    params: {},
    favorite: "",
    favoritesName : "",
    favorites: [],
    favoriteData: null,
    useFavorites: false,
    maxFavorites: 5,
    hasFullExport: false,
    hasKpis: false,
    error: false,
    savedSearchesUrl: false,
    contextStorage: null,
    batchData : {},
    mustSelectFullRow : false,
    listingMapping: null,
    filterDefinitions: {},
    metadatas: {},
    aggregations: [],
    enableContext: false
}